import { Component } from '@angular/core';

@Component({
  selector: 'app-plastic-part-processing',
  templateUrl: './plastic-part-processing.component.html',
  styleUrls: ['./plastic-part-processing.component.scss']
})
export class PlasticPartProcessingComponent {
  advanceMoullding:any[] = [
    {
      title: 'Plastic Injection Moulding',
      img: 'assets/images/capability/white/plastic_part_1.JPG',
    },
    {
      title: 'Over Moulding​',
      img: 'assets/images/capability/white/plastic_part_2.JPG',
    },
    {
      title: 'Blow Moulding',
      img: 'assets/images/capability/white/plastic_part_3.JPG',
    },
    {
      title: 'Gas Injection Moulding',
      img: 'assets/images/capability/white/plastic_part_4.JPG',
    },
    {
      title: '2K - Moulding',
      img: 'assets/images/capability/white/plastic_part_5.JPG',
    },
    {
      title: 'Insert Moulding',
      img: 'assets/images/capability/white/plastic_part_6.JPG',
    }
  ]
  produtData:any[] = [
    {
      title: 'Auto Interior Modules',
      img: 'assets/images/capability/white/plastic_part_7.JPG',
    },
    {
      title: 'Auto Exterior Modules​​',
      img: 'assets/images/capability/white/plastic_part_8.JPG',
    },
    {
      title: 'High Precious Part',
      img: 'assets/images/capability/white/plastic_part_9.JPG',
    },
    {
      title: 'White-Goods Parts​​​',
      img: 'assets/images/capability/white/plastic_part_10.JPG',
    },
    {
      title: 'Medical Segment Parts',
      img: 'assets/images/capability/white/plastic_part_11.JPG',
    },
    {
      title: 'Telecom Parts​​',
      img: 'assets/images/capability/white/plastic_part_12.JPG',
    }
  ]  
  materialExpertise:any[] = [
    { 'item': 'PP'},
    { 'item': 'ABS'},
    { 'item': 'Nylon'},
    { 'item': 'PC'},
    { 'item': 'PBT'},
    { 'item': 'PMMA'},
    { 'item': 'Other Engineering Plastic'},
  ]
  sizeandprecision:any[] = [
    { 'item': 'Up to 4000 Tonne'}
  ]
  advancemouldingtechnique:any[] = [
     { 'item':'1K/2K/3K/4K - Moulding'},
     { 'item':'Gas Assisted Injection Moulding'},
     { 'item':'Blow Moulding'},
     { 'item':'Slush Moulding'},
     { 'item':'Thermoforming'},
     { 'item':'Compression Moulding'}
  ]
  inhousetech:any[] = [
    { 'item':'Manufacturing Feasibility'},
    { 'item':'Prototyping'},
    { 'item':'Tool Designing'},
    { 'item':'Tool Manufacturing'},
    { 'item':'Moulding'},
    { 'item':'Prototyping'}
 ]
}
